import { addDays, format } from "date-fns";
import { create } from "zustand";

interface DateRange {
  from: string;
  to: string;
}

interface DashboardStore {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
}

export const useDashboardStore = create<DashboardStore>((set) => ({
  dateRange: {
    from: format(addDays(new Date(), -30), "yyyy-MM-dd"), // 30 days ago
    to: format(new Date(), "yyyy-MM-dd"),
  },
  setDateRange: (range) => set({ dateRange: range }),
}));
